// extracted by mini-css-extract-plugin
module.exports = {"AnalyticsScreen":"AnalyticsScreen_AnalyticsScreen__1LpgC","Box":"AnalyticsScreen_Box__1datS","TasksCompletedBox":"AnalyticsScreen_TasksCompletedBox__1FeAU"};